<template>
    <div class="main-content text-center">
        <h1 class="text-theme-colored mt-40 mb-0 font-60">404</h1>
        <h3 class="m-0">Page not found</h3>
    </div>
</template>

<style scoped>
.main-content {
  min-height: 80vh;
  padding: 80px 0 20px;
}
</style>

<script>
export default {
  name: 'NotFound'
}
</script>